import { Flex, useDisclosure } from '@chakra-ui/react';
import { ClearButton } from './ClearButton';
import { EditBracketNameBlock } from './EditBracketNameBlock';
import { ExitEditModeButton } from './ExitEditModeButton';
import { RandomPicksButton } from './RandomPicksButton';
import { SubmitButton } from './SubmitButton';
import { EditConferenceBonus } from '../../EditConferenceBonus';
import { ModalEditButton } from '@/modules/Bracket/components/ModalEditButton';

import { tKeys } from '@/i18n';
import {
  CHANGE_FINAL_BONUS_MODAL_STEP,
  selectBracket,
} from '@/modules/Bracket/bracket.slice';
import { FinalBonusModal } from '../../FinalBonusModal';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

export const EditModeDesktopHeader = () => {
  const dispatch = useDispatch();
  const { hasBonusValues } = useSelector(selectBracket);
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  const viewType = searchParams.get('viewType');

  const {
    isOpen: isOpenFinal,
    onClose: onCloseFinal,
    onOpen: onOpenFinal,
  } = useDisclosure({ id: 'final' });

  const onTiebreakerClick = () => {
    dispatch(CHANGE_FINAL_BONUS_MODAL_STEP(2));
    onOpenFinal();
  };

  return (
    <>
      <Flex
        align='center'
        bgColor='#192E3B80'
        gap='8px'
        h='80px'
        justify={'space-between'}
        px={{ base: '8px', lg: '40px' }}
        w={'100%'}
      >
        <EditBracketNameBlock />

        <Flex gap={{ base: '8px', lg: '10px' }}>
          <RandomPicksButton h='52px' px={{ base: '12px', lg: '24px' }} />
          <ClearButton h='52px' px={{ base: '12px', lg: '24px' }} />
        </Flex>

        <Flex gap={{ base: '8px', lg: '10px' }}>
          <ExitEditModeButton h='52px' px={{ base: '12px', lg: '24px' }} />
          <SubmitButton h='52px' px={{ base: '12px', lg: '24px' }} />
        </Flex>
      </Flex>

      {viewType !== 'edit' && (
        <Flex
          w='100%'
          justify='center'
          align='center'
          p='2'
          bgColor='#192E3B80'
        >
          <Flex gap='16px' align='center'>
            {(hasBonusValues.west || hasBonusValues.east) && (
              <EditConferenceBonus />
            )}
            {/* <ModalEditButton onClick={onTiebreakerClick}>
              {t(tKeys.tieBreaker)}
            </ModalEditButton> */}

            <FinalBonusModal isOpen={isOpenFinal} onClose={onCloseFinal} />
          </Flex>
        </Flex>
      )}
    </>
  );
};
